<template>  
  <mu-appbar class="XR-search-head">
    <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>        
    <div slot="default" class="search-ctrl">
      <div class="input-ctrl" @click="goSearch">
        <mu-chip v-if="searchKey !=''" class="XR-search-head-chip" @click="editKey" @delete="deleteKey" showDelete>
          {{searchKey}}
        </mu-chip>
      </div>          
      <div class="icon-ctrl" @click="goSearch()"><i class="fa fa-search"></i></div>
    </div>
    <mu-icon-menu icon=":fa fa-more" slot="right">
      <mu-menu-item to="/usercenter/index" title="个人中心"/>
      <mu-menu-item to="/" title="首页"/>
      <mu-menu-item to="/retail/cart" title="购物车"/>
    </mu-icon-menu>
  </mu-appbar>
</template>

<script>
export default {
  name : 'XR-search-head',
  data () {
    return {
      goToUrl : this.url,
      searchKey : this.$route.query.searchKey ? this.$route.query.searchKey : ''
    }
  },
  props:{
    url: String,
    mode: String
  },
  mounted:function(){

  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    editKey(){
      var url = "/retail/search?searchKey="+this.searchKey
      this.$router.push(url)
    },
    deleteKey(){
      this.$router.push("/retail/search")
    },
    goSearch(){
      if(this.mode == "list"){ //产品列表
        var url = "/retail/search?searchKey="+this.searchKey
        this.$router.push(url)
      }
      else if(this.mode == "category"){ //产品列表        
        this.$router.push('/retail/search')
      }
    }
  }
}
</script>

<style>
.XR-search-head{
  height: 48px;
  text-align: center;
}
.XR-search-head.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-search-head .mu-appbar-title {
  font-size: 16px;
}
.XR-search-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-search-head .title .title-text {
  margin: 0;
  line-height: 48px;
}


.XR-search-head .search-ctrl{
  height: 32px;
  line-height: 32px;
  border-radius: 25px;
  color:#ccc;
  overflow: hidden;
  background: rgba(255,255,255,0.3);
}
.XR-search-head .search-ctrl .input-ctrl{
  float: left;
  line-height: 32px;
  font-size: 12px;
  width: 100%;
  height: 32px;
  background: inherit;
  border: none;
  outline :none;
  text-align: left;
  padding-left: 10px;
  color:white;
}
.XR-search-head .search-ctrl .icon-ctrl{
  width: 15%;
  float: right;
  line-height: 32px;
  text-align: center;
  color:white;
  background: rgba(255,255,255,0.3);
}

.XR-search-head-chip{
  height: 26px;
  margin-top: 3px;
  padding:0 12px 0 4px;
  border-radius: 0;
}
.XR-search-head-chip .mu-chip-delete-icon{
  width: 16px;
  height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/usercenter/searchHead/searchHead.vue